'use client';

import { LinearProgress } from '@prismo-io/design-system';
import type { FC } from 'react';
import { useProgress } from './use-progress';

type Props = {
  current: number;
};

export const Progress: FC<Props> = (props) => {
  const { current } = props;

  const { percent } = useProgress(current);

  return <LinearProgress variant="determinate" value={percent} />;
};
